<template>
  <div class="row">
    <div class="col-lg-4 col-md-5">
      <!-- <button @click="show">hola</button> -->
      <user-card @changePassword="handlePasswordChange()"> </user-card>
      <members-card> </members-card>
    </div>
    <div class="col-lg-8 col-md-7">
      <edit-profile-form> </edit-profile-form>
    </div>
    <modal :show.sync="changingPassword">
      <h5 slot="header">Ingresa tu nueva contraseña</h5>
      <form @submit.prevent="updatePassword()">
        <fg-input
          type="password"
          label="Contraseña anterior"
          v-model="passwordChangeForm.old"
        ></fg-input>
        <fg-input
          label="Nueva contraseña"
          type="password"
          v-model="passwordChangeForm.new"
        ></fg-input>
        <fg-input
          label="Confirma tu contraseña"
          type="password"
          v-model="passwordChangeForm.confirm"
        ></fg-input>
        <small class="text-danger my-0">{{ passwordUpdateErrorMessage }}</small>
        <button
          class="btn btn-success w-100 my-4"
          :disabled="
            !passwordChangeForm.old ||
            !passwordChangeForm.new ||
            passwordChangeForm.new !== passwordChangeForm.confirm
          "
          native-type="submit"
        >
          Cambiar
        </button>
      </form>
    </modal>
  </div>
</template>
<script>
import EditProfileForm from "./UserProfile/EditProfileForm.vue";
import UserCard from "./UserProfile/UserCard.vue";
import MembersCard from "./UserProfile/MembersCard.vue";
import { Modal } from "src/components/UIComponents";

export default {
  components: {
    EditProfileForm,
    UserCard,
    MembersCard,
    Modal,
  },
  data() {
    return {
      changingPassword: false,
      passwordChangeForm: {
        old: "",
        new: "",
        confirm: "",
      },
    };
  },
  computed: {
    passwordUpdateErrorMessage() {
      if (
        this.passwordChangeForm.new &&
        this.passwordChangeForm.new !== this.passwordChangeForm.confirm
      ) {
        return "Las contraseñas deben coincidir";
      }
    },
  },
  methods: {
    // show() {
    //   console.log(this.$store.getters.getUserData);
    // },
    // test() {
    //   console.log("testeado");
    // },
    handlePasswordChange() {
      this.changingPassword = true;
    },
    async updatePassword() {
      this.$swal.fire({
        title: "Actualizando contraseña",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      await this.$axiosLogin
        .post(
          this.$Operations.UpdatePassword,
          {
            Header: {
              Operacion: this.$Operations.UpdatePasswordOP,
            },
            Auth: {
              Token: sessionStorage.getItem("jCxbraoQeD"),
            },
            Body: {
              passwordActual: this.passwordChangeForm.old,
              nuevaPassword: this.passwordChangeForm.new,
              nuevaPasswordRepetir: this.passwordChangeForm.confirm,
            },
          },
          {
            timeout: 5000, // Tiempo en milisegundos, aquí 5000ms (5 segundos)
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: this.$Operations.UpdatePasswordOP,
            },
          }
        )
        .then((res) => {
          const response = res.data.Response;
          // console.log(response.DataOut);
          // console.log("response*************************");
          // console.log(response);
          if (
            response.Resultado.CodigoHTTP === 200 ||
            response.Resultado.CodigoHTTP === 201
          ) {
            this.passwordChangeForm = {
              old: "",
              new: "",
              confirm: "",
            };
            this.changingPassword = false;
            this.$swal
              .fire({
                title: "Exito! :)",
                text: "Tu contraseña ha sido actualizada, debes volver a inciar sesión",
                icon: "success",
                showConfirmButton: true,
              })
              .then((res) => {
                sessionStorage.setItem("jCxbraoQeD", null);
                this.$router.push("/Login");
              });
          } else {
            this.$swal.fire({
              title: "Error :(!",
              text:
                response.Resultado.MensajeServicio ||
                "Ha ocurrido un error al actualizar tu contraseña, por favor ponte en contacto con soporte",
              icon: "error",
              confirmButtonColor: "#6bd098",
            });
          }
        })
        .catch((ex) => {
          // console.log("ex*******************")
          // console.log(ex)
          this.$swal.fire({
            title: "Error! :(",
            text:
              ex.response.data.Response.Resultado.MensajeServicio ||
              "Ha ocurrido un error inesperado, ponte en contacto con soporte",
            icon: "error",
            confirmButtonColor: "#6bd098",
          });
        });
    },
  },
  mounted() {
    this.$swal.close();
  },
};
</script>
<style></style>
